export const PATHS = {
  dashboard: "/dashboard",
  slaDashboard: "/slaDashboard",
  rmSlaDashboard: "/rmSlaDashboard",
  flmDispatcherDashboard: "/flmDispatcherDashboard",
  slmDispatcherDashboard: "/slmDispatcherDashboard",
  dashboardDetail: "/dashboard-detail",
  slaDashboardDetail: "/sla-dashboard-detail",
  createTicket: "/create-ticket",
  createFacilityTickets: "/create-ticket/facilities",
  createCustomerComplaint: "/create-ticket/customer-complaint",
  createRemoteSupportRequest: "/create-ticket/remote-support",
  createCustomerService: "/create-ticket/customer-service",
  createEtisalatThirdParty: "/create-ticket/etisalat-third-party",
  createUnusualEvent: "/create-ticket/unusual-event",
  createAccidentIncidentReporting:
    "/create-ticket/accident-incident-reporting/standard",
  createAccidentIncidentReportingUrgent:
    "/create-ticket/accident-incident-reporting/urgent",
  createVoiceOfStaff: "/create-ticket/voice-of-staff",
  createMarketing: "/create-ticket/marketing",
  createPanicAlertIncident: "/create-ticket/panic-alert",
  createTGSIHelpDesk: "/create-ticket/tgsi-help-desk",
  createMissedDelayedService: "/create-ticket/missed-delayed-service",

  bulkOperation: "/bulk-operations",
  createBulkTicket: "/create-ticket/bulk",
  closeBulkTicket: "/close-ticket/bulk",
  closeBulkCashTicket: "/close-tickets/cash/bulk",

  openTickets: "/open-tickets",
  assignedTickets: "/assigned-tickets",
  cashTickets: "/cash-tickets",
  vaultAccessTickets: "/vault-access-tickets",
  closedTickets: "/closed-tickets",
  cancelledTickets: "/cancelled-tickets",
  awaitingTickets: "/awaiting-tickets",
  resolvedTickets: "/resolved-awaiting",
  allTickets: "/all-tickets",
  gunnebo: "/gunnebo-tickets",
  nonGunnebo: "/non-gunnebo-tickets",
  ticketDetails: "/ticket-details",
  taskDetails: "/task-details",
  tgsiTicketDetails: "/ticket-details/tgsi",
  missedDelayedServiceDetails: "/ticket-details/missed-delayed-service",
  voiceOfStaffDetails: "/ticket-details/voice-of-staff",
  incidentReportingDetails: "/ticket-details/incident-reporting",
  marketingDetails: "/ticket-details/marketing",
  panicAlertDetails: "/ticket-details/panic-alert",

  jobCards: "/job-cards",
  panicAlertJobCards: "/job-cards/panic-alert",
  routesManagement: "/routes-management",
  selfAssignedTickets: "/self-assigned-tickets",
  changePassword: "/change-password",
  profile: "/profile",
  reports: "/reports",
  generatedReport: "/generated-report",
  serviceTicketReports: "/service-ticket-reports",
  allCalls: "/all-calls",
  openCalls: "/open-calls",
  cashCalls: "/cash-calls",
  assignedCalls: "/assigned-calls",
  resolvedCalls: "/resolved-calls",
  closedCalls: "/closed-calls",
  cancelledCalls: "/cancelled-calls",
  myCalls: "/self-calls",
  allServiceAndNonServiceCalls: "/all-service-non-service-calls",
  panicAlertCalls: "/panic-alert-calls",
  accidentIncidentCalls: "/accident-incident-calls",
  dynamicFiltering: "/dynamic-filtering-test",
  appVerification: "/app-verification",

  csMonitoringOpenCalls: "/cs-monitoring/open-calls",
  csMonitoringClosedCalls: "/cs-monitoring/closed-calls",
  csMonitoringAllCalls: "/cs-monitoring/all-calls",
  csMonitoringAssignedCalls: "/cs-monitoring/assigned-calls",
  csMonitoringSelfAssignedCalls: "/cs-monitoring/self-assigned-calls",
  panicAlertTaskDetails: "/panic-alert/task-details",
};
